import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export default StyleSheet.create({
  container: {
    backgroundColor: '#F2F2F2',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    backgroundColor: '#ffff',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
  },
  text: {
    marginHorizontal: 5,
    fontWeight: '700',
    fontSize: 16,
  },
  body: {
    padding: 10,
    margin: 10,
  },
  imageContainer: {
    backgroundColor: '#ffff',
    width: '100%',
    height: '100%',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  flexFull: {
    flex: 1,
  },
  flexSemiFull: {
    flex: 0.75,
  },
  contentCenter: {
    justifyContent: 'center',
  },
  rotated180: {
    transform: [{ scaleY: -1 }, { scaleX: -1 }],
    flexDirection: 'row-reverse',
  },
  showWordButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: colors.white,
    color: '#3a3a3a',
    borderRadius: 8,
    paddingHorizontal: 10,
    marginLeft: 20,
    height: 40,
    justifyContent: 'center',
  },
  showWordText: {
    fontSize: 18,
    fontWeight: '600',
    color: '#3a3a3a',
  },
});
